import { render, staticRenderFns } from "./CustomListFullScreen.vue?vue&type=template&id=24af31f2&scoped=true"
import script from "./CustomListFullScreen.vue?vue&type=script&lang=js"
export * from "./CustomListFullScreen.vue?vue&type=script&lang=js"
import style0 from "./CustomListFullScreen.vue?vue&type=style&index=0&id=24af31f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24af31f2",
  null
  
)

export default component.exports